<template>
  <div>
    <Tabs
      v-model="tabsValue"
      @on-click="handleTapChange"
      style="margin-top: 20px"
    >
      <TabPane
        v-for="(item, index) in contentType"
        :label="item.name"
        :name="item.name"
        :key="index"
      ></TabPane>
    </Tabs>
    <el-card>
      <div
        v-show="tabsValue == '制作音视频内容' || tabsValue == '查看音视频内容'"
      >
        <addBookContent
          :contentInfo="contentInfo"
          :doWhatTemp="doWhatTemp"
        ></addBookContent>
      </div>
      <div
        v-show="tabsValue == '制作电子书内容' || tabsValue == '查看电子书内容'"
      >
        <PreviewBar
          :book.sync="book"
          :currIndex.sync="currIndex"
          :doWhat="doWhatTemp"
          @previewHandle="previewHandler"
          :pdfChgMode.sync="chgMode"
        />
        <PointInteract
        :doWhatTemp="doWhatTemp"
         :contentInfo="contentInfo"
          v-if="showEditPanel"
          :pointEditor.sync="formForBasicInfo"
          :ind="pointIndex"
          @backToEdit="pointBackToEdit"
          :doWhat="doWhatTemp"
          style="margin-top: 50px"
        ></PointInteract>
      </div>
      <el-button
        @click="doupStep2('formCustom2')"
        style="float: right; margin: 20px 4px"
        v-if="this.$route.query.do == 'edit'"
        >上一步</el-button
      >
        <el-button
        @click="doupStep3('formCustom3')"
        style="float: right; margin: 20px 4px"
        v-if="this.$route.query.do == 'view'"
        >上一步</el-button
      >
      <el-button
        @click="doNextStep('formCustom')"
        style="float: right; margin: 20px 0"
        v-if="this.$route.query.do == 'edit'"
        >确定</el-button
      >
      <el-button
        @click="doNextStep1('formCustom1')"
        style="float: right; margin: 20px 0"
        v-if="this.$route.query.do == 'view'"
        >确定</el-button
      >
    </el-card>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { deepObjectCopy } from "@/utils/tools";
import addBookContent from "./components/addBook/addBookContent";
import PreviewBar from "./components/addBook/PreviewBar";
import PointInteract from "./components/addBook/PointInteract";
export default {
  name: "addContent",
  data() {
    return {
      tabsValue: "",
      //contentType: [{ name: "制作音视频内容" }, { name: "制作电子书内容" }],
      contentType: [],
      book: null,
      contentInfo: {
        duration: null,
        audio: "",
        explainAudio: "",
        explainDuration: null,
        artist: "",
        video: "",
        poster: "",
        videoDuration: null,
        mode: 0,
      },
      currIndex: null,
      chgMode: false,
      pageData: {
        readPoints: [],
      },
      showEditPanel: false,
      formForBasicInfo: {
        audio: "",
        duration: null,
        explainAudio: "",
        explainAudioDuration: null,
      },
      pointIndex: null,
      doWhatTemp: "",
    };
  },
  components: { addBookContent, PreviewBar, PointInteract },
  props: {},
  created() {
    this.doWhatTemp = this.$route.query.do;
    let doStr = "";
    if (this.doWhatTemp == "view") {
      doStr = "查看";
      this.contentType = [
        { name: "查看音视频内容" },
        { name: "查看电子书内容" },
      ];
    } else if (this.doWhatTemp == "edit") {
      doStr = "制作";
      this.contentType = [
        { name: "制作音视频内容" },
        { name: "制作电子书内容" },
      ];
    }
    let type = this.$route.query.content;
    if (type == "audio") {
      this.tabsValue = doStr + "音视频内容";
    } else if (type == "ebook") {
      this.tabsValue = doStr + "电子书内容";
    }
    this.fetchquery().then((res) => {
      if (res != null) {
        this.book = JSON.parse(res);
        this.contentInfo.artist = this.book.artist;
        if (this.book.content.video != undefined) {
          this.contentInfo.video = this.book.content.video;
        }
        if (this.book.content.videoDuration != undefined) {
          this.contentInfo.videoDuration = this.book.content.videoDuration;
        }
        if (this.book.content.audio != undefined) {
          this.contentInfo.audio = this.book.content.audio;
        }
        if (this.book.content.duration != undefined) {
          this.contentInfo.duration = this.book.content.duration;
        }
        if (this.book.content.explainAudio != undefined) {
          this.contentInfo.explainAudio = this.book.content.explainAudio;
        }
        if (this.book.content.explainDuration != undefined) {
          this.contentInfo.explainDuration = this.book.content.explainDuration;
        }
        if (this.book.content.mode != undefined) {
          this.contentInfo.mode = this.book.content.mode;
        } else {
          this.contentInfo.mode = 0;
        }
        if (this.book.content.poster != undefined) {
          this.contentInfo.poster = this.book.content.poster;
        }
      }
    });
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {
    fetchquery() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: Number(this.$route.query.bookid),
          dbId: Number(this.$route.query.cpid),
        };
        this.$axios
          .post("/aries-api/resource/get", params)
          .then((response) => {
            console.log(response);
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    doNextStep(name) {
      this.book.appId = this.$API.APPID;
      this.book.artist = this.contentInfo.artist;
      this.book.content.video = this.contentInfo.video;
      this.book.content.videoDuration = this.contentInfo.videoDuration;
      this.book.content.poster = this.contentInfo.poster;
      this.book.content.audio = this.contentInfo.audio;
      this.book.content.duration = this.contentInfo.duration;
      this.book.content.mode = this.contentInfo.mode;
      this.book.content.explainAudio = this.contentInfo.explainAudio;
      this.book.content.explainDuration = this.contentInfo.explainDuration;
      this.sendAddRequest(this.book, name);
    },
    doNextStep1(name) {
      if (name == "formCustom1") {
        this.$router.push({
          name: "library",
        });
      }
    },
    doupStep2(name) {
      if (name == "formCustom2") {
        this.$router.go(-1);
      }
    },
    doupStep3(name) {
      if (name == "formCustom3") {
        this.$router.go(-1);
      }
    },

    sendAddRequest(params, name) {
      // debugger
      this.$axios
        .post("/aries-api/resource/save", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == "0") {
            let id = response.data.data.id;
            let cpid = response.data.data.dbId;
            if (name == "formCustom") {
              this.jumpToEditorPage(id, cpid);
            }
          } else {
            alert(
              "post failed:" + response.data.result + ". " + response.data.msg
            );
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    jumpToEditorPage(id, cpid) {
      this.$router.push({
        name: "library",
      });
    },
    handleTapChange(tabName) {},
    previewHandler(type, params) {
      switch (type) {
        case "select":
          this.selectPage(params);
          break;
        case "delete":
          this.delPage(params);
          break;
        case "resort":
          this.resortPage(params);
          break;
        case "addPage":
          this.addPage(params);
          break;
        case "chgPageImage":
          this.chgPageImage(params);
          break;
        case "chgPagePDF":
          this.chgPagePDF(params);
          break;
        case "chgPDFInsertPage":
          this.chgPDFInsertPage(params);
          break;
        case "hidden":
          this.hiddenPage(params);
          break;
        case "multyAudio":
          this.saveMultyAudio();
          break;
        default:
          break;
      }
    },
    selectPage(item) {
      this.pageData.readPoints = [];
      this.pageData = Object.assign({}, this.pageData, item);
      this.showEditPanel = true;

      this.formForBasicInfo.audio = "";
      this.formForBasicInfo.duration = null;
      this.formForBasicInfo.explainAudio = "";
      this.formForBasicInfo.explainAudioDuration = null;

      if (this.pageData.readPoints.length > 0) {
        if (this.pageData.readPoints[0].audio != undefined) {
          this.formForBasicInfo.audio = this.pageData.readPoints[0].audio;
        }
        if (typeof this.pageData.readPoints[0].duration != "undefined") {
          this.formForBasicInfo.duration = this.pageData.readPoints[0].duration;
        }
        if (this.pageData.readPoints[0].scripts != undefined) {
          if (this.pageData.readPoints[0].scripts.length > 0) {
            if (this.pageData.readPoints[0].scripts[0].type == "audio") {
              this.formForBasicInfo.explainAudio =
                this.pageData.readPoints[0].scripts[0].config.content;
              this.formForBasicInfo.explainAudioDuration =
                this.pageData.readPoints[0].scripts[0].config.duration;
            }
          }
        }
      }
    },
    delPage(idx) {
      this.book.content.pages.splice(idx, 1);
      if (this.book.content.pages.length == 0) {
        this.showEditPanel = false;
      }
      //this.pageData.readPoints = [];
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              if (this.book.content.pages.length == 0) {
                this.pageData.readPoints = [];
              }
              this.$Message.success("删除成功!");
            }
          });
        }
      });
    },
    resortPage(params) {
      this.book.content.pages = params;
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("调整成功!");
            }
          });
        }
      });
    },
    addPage(params) {
      let insertPos = 0;
      if (this.currIndex != null) {
        insertPos = Number(this.currIndex) + 1;
      }
      for (let i in params) {
        this.book.content.pages.splice(
          Number(insertPos) + Number(i),
          0,
          params[i]
        );
      }

      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("添加成功!");
            }
          });
        }
      });
    },
    chgPageImage(params) {
      for (let i in params) {
        let index = Number(params[i].name) - 1;
        let len = this.book.content.pages.length;
        if (index < len) {
          this.book.content.pages[index].image[0] = params[i].url;
        }
      }
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("替换成功!");
            }
          });
        }
      });
    },
    chgPagePDF(params) {
      let newPage = params[0];
      let newPDFAddress = params[1];
      let chgLen = newPage.length;
      let sourceLen = this.book.content.pages.length;
      if (chgLen != sourceLen) {
        alert("上下页面数量不一致，不允许替换，请把页面数量调整至一致！");
        return;
      }
      if (newPDFAddress != "") {
        this.book.content.pdf = newPDFAddress;
      }
      for (let i in newPage) {
        this.book.content.pages[i].name = newPage[i].name;
        this.book.content.pages[i].image = newPage[i].image;
      }
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("替换成功!");
              this.chgMode = false;
            }
          });
        }
      });
    },
    chgPDFInsertPage(param) {
      let insetIndex = param[1];
      let insetItem = param[0];
      this.book.content.pages.splice(insetIndex, 0, insetItem);
    },
    hiddenPage(params) {
      let index = params;
      if (
        this.book.content.pages[index].isHidden == undefined ||
        this.book.content.pages[index].isHidden == 0
      ) {
        this.book.content.pages[index].isHidden = 1;
      } else if (this.book.content.pages[index].isHidden == 1) {
        this.book.content.pages[index].isHidden = 0;
      }
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("操作成功!");
            }
          });
        }
      });
    },
    saveMultyAudio() {
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              //this.$Message.success("上传成功!");
            }
          });
        }
      });
    },
    bookSave2Server() {
      return new Promise((resolve, reject) => {
        this.book.appId = this.$API.APPID;
        this.$axios
          .post("/aries-api/resource/save", this.book)
          .then((response) => {
            console.log(response);
            if (response.data.result == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    basicInfoSave2Server(idx) {
      if (this.pageData.readPoints.length == 0) {
        let temp = {
          name: `f${this.currIndex + 1}-1`,
          OID: "",
          positionDesc: "",
          text: "",
          audio: this.formForBasicInfo.audio,
          duration: this.formForBasicInfo.duration,
          video: "",
          game: "",
          scripts: [],
          role: "",
          emotion: "",
          apply_type: 0,
          position: ["rect", 100, 100, 100, 100, true],
        };
        this.pageData.readPoints.push(temp);
      } else {
        this.pageData.readPoints[0].audio = this.formForBasicInfo.audio;
        this.pageData.readPoints[0].duration = this.formForBasicInfo.duration;
      }
      this.pageSave2Server();
    },
    addInteract(idx) {
      let interact = {
        id: "1",
        type: "audio",
        config: {
          content: this.formForBasicInfo.explainAudio,
          duration: this.formForBasicInfo.explainAudioDuration,
        },
      };
      if (this.pageData.readPoints.length == 0) {
        let temp = {
          name: `f${this.currIndex + 1}-1`,
          OID: "",
          positionDesc: "",
          text: "",
          audio: "",
          duration: null,
          video: "",
          game: "",
          scripts: [],
          role: "",
          emotion: "",
          apply_type: 0,
          position: ["rect", 100, 100, 100, 100, true],
        };
        temp.scripts.push(interact);
        this.pageData.readPoints.push(temp);
      } else {
        this.pageData.readPoints[0].scripts = [];
        this.pageData.readPoints[0].scripts.push(interact);
      }
      this.pageSave2Server();
    },
    delInteract() {
      this.pageData.readPoints[0].scripts = [];
      this.pageSave2Server();
    },
    pageSave2Server() {
      let pageTemp = deepObjectCopy(this.pageData);
      this.book.content.pages[this.currIndex] = Object.assign(
        {},
        this.book.content.pages[this.currIndex],
        pageTemp
      );
      this.bookSave2Server().then((res) => {
        if (res != null) {
          this.fetchquery().then((res2) => {
            if (res2 != null) {
              this.book = JSON.parse(res2);
              this.$Message.success("保存成功!");
            }
          });
        }
      });
    },
    pointBackToEdit(param, idx) {
      if (param == "delAudio" || param == "addAudio") {
        this.basicInfoSave2Server(idx);
      } else if (param == "addExplainAudio") {
        this.addInteract();
      } else if (param == "delExplainAudio") {
        this.delInteract();
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// addContent.vue?312d8f92